<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('题库新')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>&nbsp;&nbsp;
          <a @click="handleDoctorRegister(record)">规则</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <doctor-register-modal ref="DoctorRegisterModal"></doctor-register-modal>
    <question-all-modal ref="modalForm" @ok="modalFormOk"></question-all-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import QuestionAllModal from './modules/QuestionAllModal'
  import DoctorRegisterModal from './modules/RuleModal'
  export default {
    name: 'QuestionAllList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      QuestionAllModal,DoctorRegisterModal
    },
    data () {
      return {
        description: '题库新管理页面',
        modalMisible:false,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'题号',
            align:"center",
            dataIndex: 'questionNumber'
          },
          {
            title:'标题',
            align:"center",
            dataIndex: 'title'
          },
          {
            title:'问卷描述',
            align:"center",
            dataIndex: 'templateDescribe'
          },
          {
            title:'类型模板、问题、答案 ',
            align:"center",
            dataIndex: 'type'
          },
          {
            title:'标签',
            align:"center",
            dataIndex: 'labelName'
          },
          {
            title:'模板类型',
            align:"center",
            dataIndex: 'templateType'
          },
          {
            title:'答卷次数',
            align:"center",
            dataIndex: 'count'
          },
          {
            title:'发布',
            align:"center",
            dataIndex: 'isRelease',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['isRelease'], text) : ''),
          },
          {
            title:'发布时间',
            align:"center",
            dataIndex: 'releaseTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/questionAll/questionAll/list",
          delete: "/questionAll/questionAll/delete",
          deleteBatch: "/questionAll/questionAll/deleteBatch",
          exportXlsUrl: "/questionAll/questionAll/exportXls",
          importExcelUrl: "questionAll/questionAll/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
      this.$set(this.dictOptions, 'isRelease', [{text:'是',value:'Y'},{text:'否',value:'N'}])
      this.$set(this.dictOptions, 'isWillAnswer', [{text:'是',value:'Y'},{text:'否',value:'N'}])
      this.$set(this.dictOptions, 'isShowNumber', [{text:'是',value:'Y'},{text:'否',value:'N'}])
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      handleDoctorRegister(record){
        this.$refs.DoctorRegisterModal.viewShow(record);
        this.modalMisible = true;
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>